import {useState, useContext, useEffect} from 'react';
import {LoaderContext} from "../../../../../context/LoaderContext.jsx";
import {
    deleteSchedulazioneApi,
    getSchedulazioniApi
} from "../../../../../services/SchedulazioniServices";

export const useTabellaSchedulazioni = () => {

    const [loadingData, setLoadingData] = useState(true);
    const [schedulazioni, setSchedulazioni] = useState([]);
    const [schedSel, setSchedSel] = useState(null);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const deleteSchedulazione = async () => {
        setShowConfirmDelete(false);
        startChiamata();
        const response = await deleteSchedulazioneApi(schedSel.id_schedulazione);
        if (parseInt(response.data.result) === -1) {
            setModalMsg(response.data.description);
            setShow(true);
        } else {
            setSchedulazioni(response.data.data);
        }
        endChiamata();
    }

    const getSchedulazioni = async () => {
        startChiamata();
        const response = await getSchedulazioniApi();
        setSchedulazioni(response.data.data);
        setLoadingData(false);
        endChiamata();
    }

    useEffect(() => {
        getSchedulazioni();
    }, []);

    const closeModal = () => setShow(false);

    const funzioneFiltro = (item, filtro) => {
        return (item.descrizione_batch && item.descrizione_batch.toLowerCase().includes(filtro.toLowerCase()))
            || (item.descrizione_installazione && item.descrizione_installazione.toLowerCase().includes(filtro.toLowerCase()))
            || (item.endpoint_installazione && item.endpoint_installazione.toLowerCase().includes(filtro.toLowerCase()))
            || (item.endpoint_batch && item.endpoint_batch.toLowerCase().includes(filtro.toLowerCase()))
    }

    return {
        loadingData,
        schedulazioni,
        schedSel,
        setSchedSel,
        showConfirmDelete,
        setShowConfirmDelete,
        deleteSchedulazione,
        modalMsg,
        closeModal,
        show,
        funzioneFiltro,
    };
};
